<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="loaded ? getPageTitle() : ''"
      [showLinkIcon]="!isAddingWorkflow"
      [linkIcon]="'trash'"
      (linkAction)="deleteWorkflow()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper class="full-page">


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      @if (!isSavingDraft) {
        <tidy-row>
          @if (!didMakeNewDraft) {
            @if (!isAddingWorkflow) {
              <tidy-text
                [body]="'Edit a field to save a new draft.'" />
            }
            @if (isAddingWorkflow) {
              <tidy-text
                [body]="'Edit a field to make a draft.'" />
            }
          }
          @if (didMakeNewDraft) {
            <tidy-text
              [body]="'Draft Saved.'" />
          }
        </tidy-row>
      }
      @if (isSavingDraft) {
        <tidy-row>
          <tidy-text
            [body]="'Saving Draft...'" />
        </tidy-row>
      }
      <tidy-card>
        <ng-container>
          <form [formGroup]="workflowForm" novalidate action="#">
            <tidy-row>
              <tidy-input
                label="Workflow Title"
                [icon]="'assets/svg/create.svg'"
                formControlName="name"
                [form]="workflowForm.get('name')"
                [submitted]="submitted"
                [errorMessage]="'Please enter a title.'"
                outsideClick />
            </tidy-row>
            <ng-container formArrayName="tags">
              <tidy-row>
                <div class="agent-category-row">
                  @for (tagControl of tagsFormArray.controls; track $index; let i = $index; let first = $first) {
                    <div class="agent-category-item">
                      <tidy-select
                        class="fit-content"
                        [label]="first ? 'Agent Category' : 'Additional Category'"
                        [icon]="'assets/svg/list.svg'"
                        [items]="workflowTagItems"
                        [formControlName]="i"
                        [form]="tagsFormArray.at(i)"
                        (optionChange)="onTagChange(i)" />
                      @if (!first) {
                        <div
                          class="agent-category-delete"
                          (click)="removeTag(i)"></div>
                      }
                    </div>
                  }
                  <tidy-text
                    [actionBody]="'+ Add Category'"
                    (action)="addTag()"
                    class="white-link link agent-category-add" />
                </div>
              </tidy-row>
            </ng-container>
          </form>
        </ng-container>
      </tidy-card>
      <tidy-card>
        @if (selectedTrigger) {
          <tidy-drop-down-menu style="position: absolute; right: 10px; top: 0">
            <tidy-drop-down-menu-item
              icon="edit"
              (click)="changeTrigger()">
              Change Trigger
            </tidy-drop-down-menu-item>
          </tidy-drop-down-menu>
        }
        @if (selectedTrigger) {
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <div class="trigger-title-container">
              <tidy-image
                [src]="'assets/img/play.svg'"
                class="title-size" />
              <div>
                <tidy-text
                  [header]="'Trigger'" />
              </div>
            </div>
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="selectedTrigger.icon_url"
              class="title-size" />
            <tidy-text
              [body]="selectedTrigger.name" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="selectedTrigger.description" />
          </tidy-row>
          <ng-container>
            @if (shouldDisplayTriggerFiltersText()) {
              <tidy-row class="extra-top-padding">
                <strong>
                  {{'Trigger Filters' | translate}}
                </strong>
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="getTriggerFilterHeaderText()" />
              </tidy-row>
            }
            @if (workflowVersionForm?.get('trigger_data')?.get('input_values')) {
              <form [formGroup]="workflowVersionForm.get('trigger_data').get('input_values')">
                @for (input of selectedTrigger?.inputs; track input) {
                  @if (workflowVersionForm?.get('trigger_data')?.get('input_values')?.get(input?.key)) {
                    @if (input.form.type === 'number') {
                      <tidy-row>
                        <tidy-input
                          [icon]="'assets/svg/information-circle.svg'"
                          [handleUpdatesOnKeyUp]="true"
                          [label]="input.form.label"
                          [formControlName]="input.key"
                          [form]="workflowVersionForm.get('trigger_data').get('input_values').get(input.key)"
                          [submitted]="submitted"
                          [errorMessage]="'Please enter a number'"
                          [type]="input.form.type" />
                      </tidy-row>
                    }
                    @if ((input.form.type === 'multi_select' || input.key === 'assigned_to_concierge') && radioItems?.[input?.form?.label]) {
                      <tidy-row class="radio-row">
                        <tidy-radio-button
                          [label]="getFilterNameInSingular(input?.form?.label) + (' Filter:' | translate)"
                          [formControlName]="input.key + '-radio'"
                          [form]="workflowVersionForm.get('trigger_data').get('input_values').get(input.key + '-radio')"
                          (optionChange)="onRadioOptionChange($event, workflowVersionForm.get('trigger_data').get('input_values').get(input.key))"
                          [items]="radioItems[input?.form?.label]" />
                      </tidy-row>
                    }
                    @if (input.key !== 'assigned_to_concierge' && (input.form.type === 'select' || input.form.type === 'multi_select')) {
                      <tidy-row>
                        @if (input.form.type === 'multi_select' ? workflowVersionForm.get('trigger_data').get('input_values').get(input.key + '-radio')?.value !== '' : true) {
                          <tidy-select
                            #tidySelect
                            [icon]="'assets/svg/list.svg'"
                            [label]="input.form.label.toLowerCase().includes('address') ? 'Properties' : input.form.label"
                            [items]="input.items"
                            [form]="workflowVersionForm.get('trigger_data').get('input_values').get(input.key)"
                            [formControlName]="input.key"
                            [multiple]="input.form.type === 'multi_select'"
                            [class]="input.form.type === 'multi_select' ? 'extra-top-padding' : ''" />
                        }
                      </tidy-row>
                    }
                    @if (input.key === 'assigned_to_concierge' && workflowVersionForm.get('trigger_data').get('input_values').get(input.key + '-radio')?.value !== '') {
                      <tidy-row>
                        <tidy-select
                          #tidySelect
                          [icon]="'assets/svg/list.svg'"
                          [label]="'Select Option'"
                          [items]="input.items"
                          [form]="workflowVersionForm.get('trigger_data').get('input_values').get(input.key)"
                          [formControlName]="input.key" />
                      </tidy-row>
                    }
                    @if (input.form.type === 'text' && input.key !== 'email_prefix' && input.key !== 'token') {
                      <tidy-row>
                        <tidy-input
                          [icon]="'assets/svg/create.svg'"
                          [label]="input.label"
                          [formControlName]="input.key"
                          [form]="workflowVersionForm.get('trigger_data').get('input_values').get(input.key)" />
                      </tidy-row>
                    }
                    @if (input.form.type === 'text' && input.key === 'email_prefix') {
                      <tidy-row>
                        <tidy-input
                          [icon]="'assets/svg/mail.svg'"
                          [textSuffix]="emailSuffix"
                          [label]="input.form.label"
                          [formControlName]="input.key"
                          [form]="workflowVersionForm.get('trigger_data').get('input_values').get(input.key)"
                          [buttonIcon]="'content_copy'"
                          [isInputEmpty]="!workflowVersionForm.get('trigger_data').get('input_values').get(input.key).value"
                          [action]="copyEmail.bind(this, workflowVersionForm.get('trigger_data').get('input_values').get(input.key).value)" />
                      </tidy-row>
                    }
                    @if (input.form.type === 'text' && input.key === 'token') {
                      <tidy-row>
                        <tidy-input
                          [icon]="'assets/svg/information-circle.svg'"
                          [label]="'Webhook Token'"
                          [formControlName]="input.key"
                          [form]="workflowVersionForm.get('trigger_data').get('input_values').get(input.key)" />
                      </tidy-row>
                      @if (workflowVersionForm.get('trigger_data')?.get('input_values')?.get('token')?.value) {
                        <tidy-row class="webhook-url-display">
                          <div class="webhook-url-container">
                            <span class="webhook-url-text">{{ webhookUrl }}{{ workflowVersionForm.get('trigger_data')?.get('input_values')?.get('token')?.value }}</span>
                            <mat-icon
                              class="copy-icon-small"
                              (click)="copyWebhook(workflowVersionForm.get('trigger_data').get('input_values').get('token').value)">
                              content_copy
                            </mat-icon>
                          </div>
                        </tidy-row>
                      }
                    }
                    @if (input.form.type === 'textarea') {
                      <tidy-row>
                        <tidy-chip-text-area
                          [id]="'trigger'"
                          [inputKey]="input.key"
                          [inputTitle]="input.form.label"
                          [isRequired]="input.required"
                          [applyFormatting]="false"
                          (inputChange)="onTriggerInputChange($event, input.key)"
                          (inputFocusIn)="setSelectedChipTextArea(input.key)" />
                      </tidy-row>
                      @if (selectedChipTextAreaId === input.key) {
                        @for (output of selectedTriggerOutputs; track output; let outputIndex = $index) {
                          <div (click)="toggleShowTriggerOutputOptions(outputIndex)" class="output-div">
                            <tidy-row class="extra-top-padding vertical-align-middle">
                              <tidy-text
                                [body]="output?.title" />
                              <ion-icon
                                style="margin-left: 5px"
                                [name]="output?.showOptions ? 'chevron-up' : 'chevron-down'"
                                class="output-expand-icon" />
                            </tidy-row>
                          </div>
                          @if (output?.showOptions) {
                            @for (item of output?.array; track item; let even = $even; let index = $index; let first = $first) {
                              <tidy-row [ngClass]="first ? 'extra-top-padding' : ''">
                                <tidy-text
                                  [body]="'+ '" />
                                <tidy-text
                                  (click)="addTriggerChipPlaceholder(item, input.key)"
                                  [actionBody]="item.plain_title || item.title"
                                  class="link" />
                                <tidy-text
                                  [body]="(' (eg: ' | translate) + item.example + ')'" />
                                @if (item.description) {
                                  <button [matTooltip]="item.description | translate" mat-button style="margin-left: 5px; width: 10px !important; min-width: unset!important; background: none; color: inherit; border: none; padding: 0; font: inherit; cursor: pointer; outline: inherit;">
                                    <tidy-text
                                      [helper]="'?'" />
                                  </button>
                                }
                              </tidy-row>
                            }
                          }
                        }
                      }
                    }
                  }
                }
              </form>
            }
          </ng-container>
        }
        <!-- New trigger -->
        @if (!selectedTrigger) {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/play.svg'"
              class="title-size" />
            <tidy-text
              [header]="'Trigger'" />
          </tidy-row>
          <tidy-row [formGroup]="searchForm">
            <tidy-input
              #thisInput
              label="Search Triggers"
              icon="assets/svg/search.svg"
              [form]="searchForm.get('title')"
              (keyup)="searchTriggers(thisInput.value)"
              formControlName="title"
              class="title-input" />
          </tidy-row>
          @for (pTrigger of filteredTriggers; track pTrigger; let triggerIndex = $index) {
            @if (pTrigger?.data) {
              <tidy-row class="extra-top-padding vertical-align-middle">
                <tidy-image
                  [src]="pTrigger.data[0].icon_url" />
                <tidy-text
                  [body]="pTrigger?.category" />
              </tidy-row>
              @for (item of pTrigger.data; track item; let even = $even; let index = $index) {
                <tidy-row class="vertical-align-center">
                  <tidy-text
                    (action)="selectTrigger(item)"
                    [actionBody]="item.name"
                    class="link" />
                </tidy-row>
              }
            }
          }
          @if (!filteredTriggers[0]?.data) {
            @for (item of filteredTriggers; track item; let even = $even; let first = $first) {
              <tidy-row [ngClass]="first ? 'extra-top-padding' : ''">
                <tidy-text [body]="'+ '" />
                <tidy-text (action)="selectTrigger(item)" [actionBody]="item.name" class="link" />
              </tidy-row>
            }
          }
        }
      </tidy-card>
      @if (!selectedTrigger) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'Select a trigger to add actions.'" />
          </tidy-row>
        </tidy-alert>
      }
      <!-- ACTIONS -->
      @if (selectedTrigger) {
        @for (action of selectedActions; track action; let actionIndex = $index) {
          <tidy-card>
            <tidy-row class="extra-bottom-padding">
              <tidy-drop-down-menu style="position: absolute; right: 10px; top: 0" (closed)="logMenuClosed($event, actionIndex)">
                <tidy-drop-down-menu-item icon="delete_outline" (click)="deleteAction(actionIndex)">Remove Action</tidy-drop-down-menu-item>
              </tidy-drop-down-menu>
              <div style="display: flex; align-items: end;">
                <tidy-image
                  [src]="'assets/img/check.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Action'" /><span>&nbsp;</span>
                  <tidy-text
                    [header]="((actionIndex | translate) + (1 | translate))" />
                  @if ((action.state === 'edit')) {
                    <tidy-input
                      label="Title"
                      [icon]="'assets/svg/create.svg'"
                      formControlName="name"
                      [form]="getActionForm(actionIndex).get('name')"
                      (outsideClick)="action.state = null"
                      outsideClick />
                  }
                </div>
              </tidy-row>
              <form [formGroup]="getActionForm(actionIndex)" novalidate action="#">
                @if (getActionForm(actionIndex).value.id) {
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="action.icon_url"
                      class="body-size" />
                    <tidy-text
                      [body]="getActionForm(actionIndex).value.name" />
                  </tidy-row>
                  @if (action?.description) {
                    <tidy-row>
                      <tidy-text
                        [body]="action?.description || ''" />
                    </tidy-row>
                  }
                  <tidy-row class="extra-top-padding">
                    @for (input of action?.inputs; track input) {
                      @if (input?.form?.type === 'filter') {
                        <filter-nested-form
                          [filterGroups]="action?.input_values?.filter_groups"
                          [outputs]="action?.parsedOutputs"
                          [inputOptions]="action?.inputOptions"
                          (formValues)="onFormValuesChange($event, actionIndex)" />
                      }
                      @if (input?.form?.type !== 'filter') {
                        <tidy-row [formGroup]="getActionForm(actionIndex).get('input_values')">
                          @if (input.form.type === 'multiselect' || input.form.type === 'multi_select' || input.form.type === 'select') {
                            @if (!hideInput(action, input)) {
                              <tidy-select
                                [icon]="'assets/svg/list.svg'"
                                [label]="input.form.label"
                                [items]="input.options"
                                [form]="getActionForm(actionIndex).get('input_values').get(input.key)"
                                [formControlName]="input.key"
                                [multiple]="input.form.type === 'multi_select' || input.form.type === 'multiselect'"
                                (optionChange)="onOptionChange(action, actionIndex, getActionForm(actionIndex).get('input_values').get(input.key), input)" />
                            }
                          }
                          @if (getInputHint(action, input) !== '') {
                            <tidy-row>
                              <tidy-text [helper]="getInputHint(action, input)" />
                            </tidy-row>
                          }
                          @if (input.form.type !== 'files' && input.form.type !== 'select' && input.form.type !== 'multiselect' && input.form.type !== 'multi_select') {
                            @if (!hideInput(action, input)) {
                              <tidy-chip-text-area
                                [id]="getActionForm(actionIndex).get('formId').value"
                                [inputKey]="input.key"
                                [inputTitle]="input.form.label"
                                [isRequired]="input.required"
                                [applyFormatting]="false"
                                (inputChange)="onInputChange($event)"
                                (inputFocusIn)="setSelectedChipTextArea(input.key)" />
                            }
                          }
                          @if (input.form.type === 'files') {
                            <tidy-row style="margin-top: 1rem;">
                              <tidy-text
                                [actionBody]="'Add Attachment'"
                                (action)="addAttachment(action)"
                                class="link" />
                            </tidy-row>
                            @if (action?.input_values?.attachments?.length > 0) {
                              <ion-row>
                                @for (attachment of action?.input_values?.attachments; track attachment; let i = $index) {
                                  <ion-col size="12" sizeMd="6" sizeLg="4" sizeXl="3">
                                    <div
                                      style="width: 100%"
                                      class="image-preview">
                                      <img [src]="attachment" />
                                      <div class="remove-image-button">
                                        <button
                                          matSuffix
                                          mat-icon-button
                                          mat-mini-fab
                                          (click)="removeAttachment(action, i)">
                                          <mat-icon>close</mat-icon>
                                        </button>
                                      </div>
                                    </div>
                                  </ion-col>
                                }
                              </ion-row>
                            }
                          }
                          @if (selectedChipTextAreaId === input.key) {
                            @for (output of action?.outputs; track output; let outputIndex = $index) {
                              <div (click)="toggleShowOutputOptions(actionIndex, outputIndex)" class="output-div">
                                <tidy-row class="extra-top-padding vertical-align-middle">
                                  <tidy-text
                                    [body]="output?.title" />
                                  <ion-icon
                                    style="margin-left: 5px"
                                    [name]="output?.showOptions ? 'chevron-up' : 'chevron-down'"
                                    class="output-expand-icon" />
                                </tidy-row>
                              </div>
                              @if (output?.showOptions) {
                                @for (item of output?.array; track item; let even = $even; let index = $index; let first = $first) {
                                  <tidy-row [ngClass]="first ? 'extra-top-padding' : ''">
                                    <tidy-text
                                      [body]="'+ '" />
                                    <tidy-text
                                      (click)="addChipPlaceholder(item, getActionForm(actionIndex).get('formId').value, input.key)"
                                      [actionBody]="item.plain_title || item.title"
                                      class="link" />
                                    <tidy-text
                                      [body]="(' (eg: ' | translate) + item.example + ')'" />
                                    @if (item.description) {
                                      <button [matTooltip]="item.description | translate" mat-button style="margin-left: 5px; width: 10px !important; min-width: unset!important; background: none; color: inherit; border: none; padding: 0; font: inherit; cursor: pointer; outline: inherit;">
                                        <tidy-text
                                          [helper]="'?'" />
                                      </button>
                                    }
                                  </tidy-row>
                                }
                              }
                            }
                          }
                        </tidy-row>
                      }
                    }
                  </tidy-row>
                }
                <!-- New action -->
                @if (!getActionForm(actionIndex).value.id) {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-row [formGroup]="searchForm">
                      <tidy-input
                        #thisInput
                        label="Search"
                        icon="assets/svg/search.svg"
                        [form]="searchForm.get('title')"
                        (keyup)="searchActions(thisInput.value)"
                        formControlName="title"
                        class="title-input" />
                    </tidy-row>
                    @for (pAction of filteredActions; track pAction) {
                      @if (pAction?.data) {
                        <tidy-row class="extra-top-padding vertical-align-middle">
                          <tidy-image
                            [src]="pAction.data[0].icon_url" />
                          <tidy-text
                            [body]="pAction?.category" />
                        </tidy-row>
                        @for (item of pAction.data; track item; let even = $even; let index = $index) {
                          <tidy-row class="vertical-align-center">
                            <tidy-text
                              (action)="selectActionType(item, actionIndex)"
                              [actionBody]="item.name"
                              class="link" />
                          </tidy-row>
                        }
                      }
                    }
                    @if (!filteredActions[0]?.data) {
                      @for (item of filteredActions; track item; let even = $even; let first = $first) {
                        <tidy-row [ngClass]="first ? 'extra-top-padding' : ''">
                          <tidy-text
                            (action)="selectActionType(item, actionIndex)"
                            [actionBody]="item.name"
                            class="link" />
                        </tidy-row>
                      }
                    }
                  </tidy-row>
                }
              </form>
            </tidy-card>
          }
        }
        @if (selectedTrigger) {
          <tidy-row [align]="'center'">
            <tidy-text
              [actionBody]="'+ Add Action'"
              (action)="addAction()"
              class="link" />
          </tidy-row>
        }
        <tidy-row>
          <tidy-button
            (click)="$event.stopPropagation()"
            text="Publish"
            [action]="boundPublishWorkflowVersion"
            [disabled]="publishedVersionIsLatestVersion || isPublishing"
            class="primary" />
        </tidy-row>
        @if (!isAddingWorkflow) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'Delete Workflow'"
              class="red link"
              (action)="deleteWorkflow()" />
          </tidy-row>
        }
        @if (publishedVersionIsLatestVersion) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'This version has already been published. Make changes to publish a new version.'" />
          </tidy-row>
        }
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
      }

    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
